<template>
  <div class="card_batch_add_wrap">
    <div class="header">
      <el-button size="medium" @click="goBack">返回</el-button>
      <el-button size="medium" type="primary" @click="saveCard">保存</el-button>
    </div>
    <div class="card_batch_add_box" :style="`height: ${windowHeight - 170}px;`">
      <div class="card_batch_add_content">
        <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
          <el-form-item label="选择卡片" prop="templateId">
            <el-select v-model.trim="formData.templateId" placeholder="请选择">
              <el-option :label="item.name" :value="item.id" :key="index" v-for="(item, index) in templateList"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="张数" prop="buildNum">
            <el-input-number v-model="formData.buildNum" controls-position="right" :min="1" :max="1000000"></el-input-number>
          </el-form-item>
          <el-form-item label="类型" class="is-required">
              <el-radio v-model="formData.cardType" :label="2">农行卡</el-radio>
              <el-radio v-model="formData.cardType" :label="1">微信卡</el-radio>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import windowResize from '@/mixins/windowResize';
  import {getIntegralCardTemplateList, buildIntegralCard} from '@/api/integralBank';

  export default {
    name: "cardBatchAdd",
    data() {
      return {
        isLoading: false,
        templateList: [],
        formData: {
          templateId: null,
          buildNum: 100,
          cardType:2
        },
        rules: {
          buildNum: [
            {required: true, trigger: 'blur', message: '请输入张数'}
          ],
          templateId: [
            { required: true, trigger: 'blur', message: '请选择卡片' }
          ]
        },
      }
    },
    mixins: [windowResize],
    created() {
      this.getIntegralCardTemplateList();
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      getIntegralCardTemplateList() {
        getIntegralCardTemplateList().then(res => res.data).then(data => {
          if (data.code === 200 && data.result && data.data) {
            this.templateList = data.data;
            this.formData.templateId = data.data[0].id;
          }
        });
      },
      saveCard() {
        if (this.isLoading) {
          return;
        }
        this.isLoading = true;
        this.$refs.form.validate(isValid => {
          if(isValid) {
            buildIntegralCard(this.formData).then(res => res.data).then(data => {
              if (data.code === 200 && data.result) {
                this.$message.success('添加成功');
                this.goBack();
              } else {
                this.$message.success(data.msg);
              }
              this.isLoading = false;
            }).catch(() => {
              this.isLoading = false;
            });
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './../../styles/mixin';

  .card_batch_add_wrap{
    padding: 12px;

    .header {
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
    }

    .card_batch_add_box{
      @include scrollBar;

      .card_batch_add_content{
        width: 810px;
        margin: 0 auto;
        padding-top: 20px;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/integralBank/cardBatchAdd.vue